'use strict';

// Public browse URLs and the one-use handoff from server HTML to the catalog.
const INITIAL_ID = 'public-catalog-initial';
const PAGE_SIZES = Object.freeze({ tools: 60, prompts: 20 });

function pageNumber(value) {
  const raw = Array.isArray(value) ? value[0] : value;
  return typeof raw === 'string' && /^[1-9]\d{0,2}$/.test(raw) ? Number(raw) : 1;
}

function catalogHref(family, category, page = 1) {
  const path = '/' + family + (category ? '/category/' + encodeURIComponent(category) : '');
  return path + (page > 1 ? '?page=' + page : '');
}

function serializeInitial(value) {
  return JSON.stringify(value).replace(/</g, '\\u003c').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}

function takeInitial(family, filters = {}) {
  if (typeof document === 'undefined' || typeof location === 'undefined') return null;
  const node = document.getElementById(INITIAL_ID);
  if (!node || Object.keys(filters).some(key => !['category', 'skip'].includes(key))) return null;
  try {
    const value = JSON.parse(node.textContent);
    const size = PAGE_SIZES[family];
    if (!size || value.family !== family || value.path !== location.pathname
      || value.page !== pageNumber(new URL(location.href).searchParams.get('page'))
      || (value.category || '') !== (filters.category || '')
      || value.data?.pagination?.skip !== Number(filters.skip || 0)
      || value.data.pagination.limit !== size || !Array.isArray(value.data[family])
      || value.data[family].length > size) return null;
    node.remove();
    return value.data;
  } catch {
    return null;
  }
}

module.exports = { INITIAL_ID, PAGE_SIZES, pageNumber, catalogHref, serializeInitial, takeInitial };
